// extracted by mini-css-extract-plugin
export default {"stats":"Stats_stats__tP5la"};